app.controller('accountHomeController', ['$scope', '$state', 'objectHelper', 'applicationModel', 'userModel',
    function ($scope, $state, objectHelper, applicationModel, userModel) {

        function setData() {
            $scope.currentUser = userModel.currentUser;

            $scope.forms = {
                accountForm: null
            }
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on('$destroy', function(event) {
                applicationModel.viewReady = false;
            });
        }

        function setActions() {
            $scope.changePassword = function() {
                $state.go(Constant.STATE.APP.ACCOUNT.CHANGE_PASSWORD);
            };
        }

        function configureInterface() {
            applicationModel.deselectSideBarItems();

            var breadcrumbItems = [
                objectHelper.o(EsBreadcrumbItem, { name: 'T.UI.BREADCRUMB.ACCOUNT.MY_ACCOUNT', state: Constant.STATE.APP.ACCOUNT.HOME })
            ];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MODULE.ACCOUNT.MY_ACCOUNT');
        }

        function initialize() {
            applicationModel.viewReady = true;
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
